import { Component } from '@angular/core';

@Component({
  selector: 'app-upcoming-statement',
  templateUrl: './upcoming-statement.component.html',
  standalone: false,
})
export class UpcomingStatementComponent {
  public showThis: boolean = false;

  checkShowNewStatementAnnouncement() {
    let now = new Date();
    var lastDayOfThisMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    var endOfFirstWeekNextMonth = new Date(
      now.getFullYear(),
      now.getMonth() + 1,
      7,
    );
    this.showThis = now >= lastDayOfThisMonth && now <= endOfFirstWeekNextMonth;
  }
  
  constructor() {
    // this.checkShowNewStatementAnnouncement(); // <== disable for now until statements are implemented
  }
}
